import { defineComponent } from '~/scripts/utils/alpine'

interface DrawSvgOptions {
  reverse?: boolean
}

/**
 * DrawSvg component
 * @example the variable `draw` is coming from a parent component
 * <div x-data="DrawSvg" x-model="draw">
 *   <svg viewBox="0 0 100 100">
 *     <path x-bind="path" d="M0 0 L100 100" />
 *   </svg>
 * </div>
 */
export default defineComponent((options: DrawSvgOptions = {}) => {
  const { reverse = false } = options

  return {
    _draw: false,
    root: {
      'x-modelable': '_draw',
    },
    path: {
      'pathLength': '1',
      'stroke-dasharray': '1',
      ':stroke-dasharray': function () {
        return reverse ? 2 : 1
      },
      'stroke-dashoffset': '1',
      ':stroke-dashoffset': function () {
        if (this._draw) {
          return reverse ? 4 : 0
        }
        return reverse ? 2 : 1
      },
      'x-modelable': '_draw',
      'class': 'transition-[stroke-dashoffset] duration-1500 ease-in-out-cubic',
    },
  }
})
